import { createSlice } from '@reduxjs/toolkit';
import { fontsInitialState } from './fontsInitialState';

export const { actions, reducer } = createSlice({
    name: 'fonts',
    initialState: fontsInitialState,
    reducers: {
        updateStatus: (state, action) => {
            return state.map(font => font.name === action.payload.name
                ? { ...font, status: action.payload.status }
                : font);
        }
    }
});

export const { updateStatus } = actions;